module.exports = __webpack_public_path__ + "static/media/KPMG-Logo.7e88bee8.png";